import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { Button } from "antd";
import { useHistory } from "react-router-dom";
import * as ROUTES from "../../../constants/routeConstants";
import { REGISTRATION_LIST_MODE } from "./MyRegistrationsConstants";

function MyRegistrationItemAction({ regId, regIsClosed, listMode }) {
  const history = useHistory();

  const handleRegContinueClick = useCallback(() => {
    history.push(`${ROUTES.USER_REGISTRATIONS}/${regId}/submit`);
  }, [regId, history]);

  const handleViewNewRegistrationClick = useCallback(() => {
    history.push(`${ROUTES.USER_REGISTRATIONS}/${regId}`);
  }, [regId, history]);

  if (regIsClosed) {
    return null;
  }

  if (listMode === REGISTRATION_LIST_MODE.CURRENT) {
    return (
      <Button icon="edit" type="primary" onClick={handleRegContinueClick}>
        Continue Registration
      </Button>
    );
  }

  if (listMode === REGISTRATION_LIST_MODE.NEW) {
    return (
      <Button icon="plus" type="primary" onClick={handleViewNewRegistrationClick}>
        View Registration
      </Button>
    );
  }

  return <Button onClick={handleRegContinueClick}>View Registration</Button>;
}

MyRegistrationItemAction.propTypes = {
  regId: PropTypes.string.isRequired,
  regIsClosed: PropTypes.bool.isRequired,
  listMode: PropTypes.oneOf(Object.values(REGISTRATION_LIST_MODE)).isRequired,
};

export default MyRegistrationItemAction;
